import axios from '../utils/axios'

export function WxJsSignatureInfo (params) {
  return axios({
    url: '/WechatService/WxJsSignatureInfo',
    method: 'get',
    params: params
  })
}
